import Component from "../classes/Component"
import each from 'lodash/each'

import { app, menu, navigation } from '../utils/store'

import { PrivacyManager } from '../classes/Privacy'

import gsap from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)

export class Navigation extends Component {
    constructor({ init = false }) {
        super({
            element: '[data-navigation]',
            elements: {
                main: '[data-navigation-main] [data-main]',
                top: '[data-navigation-top]',
                promo: '[data-navigation-promo]',
                actions: '[data-main-actions]',
                dropdowns: 'dropdown-menu',
                toggler: '[data-menu-toggler]',
                search: 'form[role="search"]',
                language: '#select-language',
            }
        })

        // app.scroll = app.scroll ? app.scroll : window

        // this.scroll = {
        //     previousY: 0,
        //     previousRatio: 0,
        //     currentY: null,
        //     currentRatio: null,
        // }

        document.addEventListener('DOMContentLoaded', () => {
            //this.createObserver()
        })
    }

    create() {
        super.create()

        app.nav = this.element
        app.root.style.setProperty('--window-height', `${window.innerHeight}px`)
        app.root.style.setProperty('--window-width', `${window.innerWidth}px`)

        app.root.style.setProperty('--viewport-height', `${window.visualViewport.height}px`)

        if (this.elements.promo) {
            app.root.style.setProperty('--navigation-promo-height', `${this.elements.promo.clientHeight}px`)
            app.root.style.setProperty('--navigation-height', `${(app.nav.clientHeight - this.elements.promo.clientHeight)}px`)
        } else {
            app.root.style.setProperty('--navigation-promo-height', `0px`)
            app.root.style.setProperty('--navigation-height', `${app.nav.clientHeight}px`)
        }

        if (this.elements.top) {
            app.root.style.setProperty('--navigation-top-height', `${app.nav.querySelector('[data-navigation-top]').clientHeight}px`)
        } else {
            app.root.style.setProperty('--navigation-top-height', `0px`)
        }

        if (this.elements.actions) {
            app.root.style.setProperty('--actions-height', `${this.elements.actions.clientHeight}px`)
        } else {
            app.root.style.setProperty('--actions-height', `0px`)
        }

        if (this.elements.search) {
            app.root.style.setProperty('--search-submit-height', `${this.elements.search.querySelector('button').clientHeight}px`)
        } else {
            app.root.style.setProperty('--search-submit-height', `0px`)
        }

        if (this.elements.language) {
            app.language = {
                current: [],
                togglers: document.querySelectorAll('#language-toggler'),
                select: document.querySelector('[data-modal-language] ul.language-selector')
            };

            each(this.elements.language, (entry) => {
                if (entry instanceof window.HTMLElement) {
                    app.language.current.push(entry.getAttribute('data-current-language'));
                }
            });
        }

        if (!app.bundle && this.elements.toggler) {
            this.elements.toggler.addEventListener('click', (event) => this.onClick(event)) // Use addEventListener
        }
    }

    addEventListeners() {
        window.addEventListener('resize', () => {
            app.root.style.setProperty('--window-height', `${window.innerHeight}px`)
            app.root.style.setProperty('--window-width', `${window.innerWidth}px`)
            if (this.elements.promo) {
                app.root.style.setProperty('--navigation-promo-height', `${this.elements.promo.clientHeight}px`)
                app.root.style.setProperty('--navigation-height', `${(app.nav.clientHeight - this.elements.promo.clientHeight)}px`)
            } else {
                app.root.style.setProperty('--navigation-promo-height', `0px`)
                app.root.style.setProperty('--navigation-height', `${app.nav.clientHeight}px`)
            }

            if (this.elements.top) {
                app.root.style.setProperty('--navigation-top-height', `${app.nav.querySelector('[data-navigation-top]').clientHeight}px`)
            } else {
                app.root.style.setProperty('--navigation-top-height', `0px`)
            }
        })

        window.visualViewport.addEventListener('resize', () => {
            app.root.style.setProperty('--viewport-height', `${window.visualViewport.height}px`)
        })

        if (app.bundle && app.scroll) {
            app.scroll.addEventListener('scroll', (event) => this.onScroll(event))
        }
    }

    onClick(event) {
        event.preventDefault()
        event.stopPropagation(); // Prevent event propagation

        app.html.classList.toggle('scroll--off')
        app.root.classList.toggle('navigation--open')
        app.root.classList.remove('menu--open')

        if (this.elements.dropdowns) { each(this.elements.dropdowns, (entry) => { entry.classList.remove('show') }) }
        if (menu.current) { menu.current.classList.remove('active') }

        if (!navigation.isOpen) {
            navigation.isOpen = true
            navigation.current = this.elements.main
        } else {
            navigation.isOpen = false
            navigation.current = null
        }

        menu.isOpen = false
        menu.current = null
    }

    onScroll = (event) => {
        if (app.scroll == window) { this.scrollTop = window.scrollY }
        else { this.scrollTop = app.scroll.scrollTop }

        if (this.scrollTop > app.nav.clientHeight) {
            this.element.classList.add('navigation--active')
        } else {
            this.element.classList.remove('navigation--active')
        }

        if (this.elements.promo) {
            app.root.style.setProperty('--navigation-promo-height', `${this.elements.promo.clientHeight}px`)
            app.root.style.setProperty('--navigation-height', `${(app.nav.clientHeight - this.elements.promo.clientHeight)}px`)
        } else {
            app.root.style.setProperty('--navigation-promo-height', `0px`)
            app.root.style.setProperty('--navigation-height', `${app.nav.clientHeight}px`)
        }

        //BRUNO simplified way to manager menu change color, todo improve performance by using Interceptor
        // each(document.querySelectorAll('header[mode], section[mode], footer[mode]'), (section) => {
        //     if (this.elementsOverlap(section, document.querySelectorAll('[data-navigation-bar]')[0])) {
        //         if (section.getAttribute('mode') != app.nav.getAttribute('mode')) {
        //             app.nav.setAttribute('mode', section.getAttribute('mode'));
        //         }
        //         return false;
        //     }
        // })
    }

    // createObserver() {
    //     this.observer = new IntersectionObserver((entries) => {
    //         entries.forEach((entry) => {

    //             const sectionMode = entry.target.getAttribute('mode')
    //             this.scroll.currentY = entry.boundingClientRect.y
    //             this.scroll.currentRatio = entry.intersectionRatio

    //             console.log("general", this.scroll.currentY, this.scroll.previousY, entry.isIntersecting, this.scroll.currentRatio, this.scroll.previousRatio)
    //             console.log(entry.target);
    //             console.log(entry.target.getAttribute('mode'));
    //             if (sectionMode) {
    //                 if (this.scroll.currentY < this.scroll.previousY) {
    //                     // console.log("1a", this.scroll.currentY, this.scroll.previousY, entry.isIntersecting, this.scroll.currentRatio, this.scroll.previousRatio)
    //                     if (this.scroll.currentRatio > this.scroll.previousRatio && entry.isIntersecting) {
    //                     } else {
    //                         if (entry.target.nextElementSibling) {
    //                             // console.log("1b", entry.target.nextElementSibling)
    //                             var isInverted = entry.target.nextElementSibling.getAttribute('mode') == "light";

    //                             if (isInverted) {
    //                                 app.nav.setAttribute('mode', 'light');
    //                             } else {
    //                                 app.nav.setAttribute('mode', 'dark');
    //                             }
    //                         }
    //                     }
    //                 } else if (entry.isIntersecting) { // "Scrolling UP" this.scroll.currentY < this.scroll.previousY &&
    //                     console.log(entry.target.getAttribute('mode'));
    //                     // console.log("2a", this.scroll.currentY, this.scroll.previousY, entry.isIntersecting, this.scroll.currentRatio, this.scroll.previousRatio)
    //                     if (this.scroll.currentRatio > this.scroll.previousRatio) { // "Scrolling UP Enter"
    //                         // console.log("2b", entry.target)
    //                         var isInverted = entry.target.getAttribute('mode') == "light";

    //                         if (isInverted) {
    //                             app.nav.setAttribute('mode', 'light');
    //                         } else {
    //                             app.nav.setAttribute('mode', 'dark');
    //                         }
    //                     } else { // "Scrolling UP Leave"
    //                     }
    //                 }
    //                 this.scroll.previousY = this.scroll.currentY
    //                 this.scroll.previousRatio = this.scroll.currentRatio
    //             }
    //         })

    //     }, {
    //         //root: document,
    //         rootMargin: `0px 0px -10% 0px`,
    //     })

    //     each(document.querySelectorAll('[mode]'), (section) => {
    //         this.observer.observe(section)
    //     })
    // }

    destroy = () => { /** Code your own */ }

    elementsOverlap(el1, el2) {
        const domRect1 = el1.getBoundingClientRect();
        const domRect2 = el2.getBoundingClientRect();

        return !(
            domRect1.top > domRect2.bottom ||
            domRect1.right < domRect2.left ||
            domRect1.bottom < domRect2.top ||
            domRect1.left > domRect2.right
        );
    }
}

export class Footer extends Component {
    constructor({ init = false }) {
        super({
            element: '[data-footer]',
            elements: {
                privacy: '[data-privacy-async]'
            }
        })

        this.init = init
    }

    async create() {
        super.create()

        app.footer = this.element
        app.root.style.setProperty('--footer-height', `${app.footer.clientHeight}px`)

        this.style = this.element.getAttribute('style')

        if (app.device.mobile) { app.footer.setAttribute('style', this.element.getAttribute('data-mobile-style')) }

        if (!app.bundle) {
            if (this.elements.privacy) {
                app.privacy = await this.elements.privacy.getAttribute('data-privacy-async')
                // app.privacy = PrivacyManager.create(this.elements.privacy)
                app.privacy = PrivacyManager.toggle(this.elements.privacy)
            }
        }
    }

    addEventListeners() {
        window.addEventListener('resize', () => app.root.style.setProperty('--footer-height', `${app.footer.clientHeight}px`))

        if (app.device.mobile) { app.footer.setAttribute('style', this.element.getAttribute('data-mobile-style')) }
        else { app.footer.setAttribute('style', this.style) }
    }

    destroy = () => { /** Code your own */ }
}